import { render, staticRenderFns } from "./SquareImg.vue?vue&type=template&id=80d04354&"
import script from "./SquareImg.vue?vue&type=script&lang=js&"
export * from "./SquareImg.vue?vue&type=script&lang=js&"
import style0 from "./SquareImg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports